import { render } from 'react-dom';
import Chrome from 'scripts/components/Chrome';
import Highlights from 'scripts/components/Highlights';

render(
	<Chrome>
		<Highlights display="topMedals" />
	</Chrome>,
	document.getElementById('rio2016TopMedals')
);



/** WEBPACK FOOTER **
 ** ./scripts/bootstrap/topMedals.es6
 **/